(function(CassiopeaTypesEnum, Utilities) {
	'use strict';
	
	const $FILTER 		= invokeAngularService('$filter');
	const MASHBOARD 	= $FILTER('translator')('Mashboard');
	const PROCESS 		= $FILTER('translator')('Process');
	const REPORT 		= $FILTER('translator')('Report');
	const BLOGPOST 		= $FILTER('translator')('BlogPost');
	const DOCUMENT 		= $FILTER('translator')('Document');
	const SOCIAL_AREA	= $FILTER('translator')('Area');
	const SOCIAL_GROUP 		= $FILTER('translator')('Group');
	const SOCIAL_INITIATIVE	= $FILTER('translator')('Initiative');
		
	const FOLDER 		= Utilities.capitalizeFirstChar($FILTER('translator')('folder'));
	const FOLDER_TYPE 	= '1';
	const LEAF_TYPE 	= '2';
	
	
	function LandingPageFactory() {

		function getTitleByContent(content){
			let label;			
			switch (content.type) {
				case FOLDER_TYPE:
					label = FOLDER;
					break;
				case LEAF_TYPE:
					switch (content.nodeInfo.casType) {
						case CassiopeaTypesEnum.MSH:
							label = MASHBOARD;
							break;
						case CassiopeaTypesEnum.PLANNING:
							label = PROCESS;
							break;
						case CassiopeaTypesEnum.REPORT:
						case 1030:// report type: crosstab
						case 1040:// report type: graph
						case 1050:// report type: document
							label = REPORT;
							break;
						case CassiopeaTypesEnum.SOCIAL_AREA_NORMAL:
							label = SOCIAL_AREA;
							break;
						case CassiopeaTypesEnum.SOCIAL_AREA_GROUP:
							label = SOCIAL_GROUP;
							break;
						case CassiopeaTypesEnum.SOCIAL_AREA_INITIATIVE:
							label = SOCIAL_INITIATIVE;
							break;
						case CassiopeaTypesEnum.SOCIAL_DOCUMENT:
							label = DOCUMENT;
							break;
						case CassiopeaTypesEnum.SOCIAL_BLOG:
							label = BLOGPOST;
							break;
						default:
							break;
					};
				default:
					break;
			};
			return label;
		}
				
		function getUploadImageType(casType){
			let imgType;
			switch (casType) {
				case CassiopeaTypesEnum.DSH_PAGE_ORGANIZED_TYPE:
					imgType = 'MSHPAGE_PREVIEW';
					break;
				case CassiopeaTypesEnum.PROCESS_ORGANIZED_TYPE:
					imgType = 'PLN_PROCESS_PREVIEW';
					break;
				default:
					break;
			}
			return imgType;
		}
		
		function getMenuComponent(id, owner, imgType, fuCtxType, srcImage){
			return {
				definer: "IMAGE_UPLOAD",
				definerOptions: {
					id					: id,
					imgType			: imgType,
					owner				: owner,
					fuCtxType 			: fuCtxType,
					isPreviewEnabled	: false,
					type				: -1
				},
				name : "",
				defaultValue: srcImage
			}; 
		}
		
		
		
		return {
			getTitleByContent	: getTitleByContent,
			getUploadImageType 	: getUploadImageType,
			getMenuComponent	: getMenuComponent
		};
		
	}

	angular
	.module('dcyApp')
	.register
	.factory('dcyLandingPageFactory', LandingPageFactory);

}(window.CassiopeaTypesEnum, window.Utilities));